/* eslint-disable react-hooks/exhaustive-deps */
import React, {createContext, useState} from "react";
import {useMemo} from "react";
import {useCallback} from "react";

export const UploadingAssetContext = createContext();
export const UploadingAssetDispatchContext = createContext();
export const UploadProgressContext = createContext();
export const UploadProgressDispatchContext = createContext();

function UploadProgressProvider({children}) {
  const [uploadProgress, setUploadProgress] = useState(13);
  const [uploadingAssetInfo, setUploadingAssetInfo] = useState({});

  const updateUploadProgress = useCallback(progress => setUploadProgress(progress), []);
  const updateUploadingAssetInfo = useCallback(info => setUploadingAssetInfo(info), []);

  const dispatch = useMemo(() => ({updateUploadProgress}), []);
  const dispatchAssetInfo = useMemo(() => ({updateUploadingAssetInfo}), []);

  return (
    <UploadProgressContext.Provider value={uploadProgress}>
      <UploadProgressDispatchContext.Provider value={dispatch}>
        <UploadingAssetContext.Provider value={uploadingAssetInfo}>
          <UploadingAssetDispatchContext.Provider value={dispatchAssetInfo}>{children}</UploadingAssetDispatchContext.Provider>
        </UploadingAssetContext.Provider>
      </UploadProgressDispatchContext.Provider>
    </UploadProgressContext.Provider>
  );
}

export default UploadProgressProvider;
